import { render } from "./App.vue?vue&type=template&id=13978a0c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=13978a0c&lang=css"

import exportComponent from "C:\\Users\\kiemp\\OneDrive\\Documents\\VSCode\\SMM2_info\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__